"use client"

// src/text.tsx
import {
  forwardRef,
  omitThemeProps,
  ui,
  useComponentStyle
} from "@yamada-ui/core";
import { cx, filterUndefined } from "@yamada-ui/utils";
import { jsx } from "react/jsx-runtime";
var Text = forwardRef((props, ref) => {
  const [css, mergedProps] = useComponentStyle("Text", props);
  const {
    className,
    align: textAlign,
    casing: textTransform,
    decoration: textDecoration,
    ...rest
  } = omitThemeProps(mergedProps);
  const textProps = filterUndefined({
    textAlign,
    textDecoration,
    textTransform
  });
  return /* @__PURE__ */ jsx(
    ui.p,
    {
      ref,
      className: cx("ui-text", className),
      __css: css,
      ...textProps,
      ...rest
    }
  );
});
Text.displayName = "Text";
Text.__ui__ = "Text";

export {
  Text
};
//# sourceMappingURL=chunk-HZUFQ4E7.mjs.map